module.exports = __webpack_public_path__ + "static/img/share-earn.0c4ee582.png";